export var EventsRequestType;
(function (EventsRequestType) {
    EventsRequestType["ByTopLeagues"] = "ByTopLeagues";
    EventsRequestType["ByEventIds"] = "ByEventIds";
    EventsRequestType["ByLeagueIds"] = "ByLeagueIds";
    EventsRequestType["ByRegionId"] = "ByRegionId";
})(EventsRequestType || (EventsRequestType = {}));
//# sourceMappingURL=EventsRequest.js.map